import { useParams, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './../pages/product.module.css';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import ProductDetails from '../components/product_details';
import QuoteDetails from '../components/quote_details';
import UserDetails from '../components/user_details';
import Navbar from '../components/navbar';
import isLoggedIn from '../utils/isLoggedIn';

const QuoteRequest = () => {
  const { id } = useParams();
  const url = `${process.env.REACT_APP_API}/admin/quoterequest/${id}`;
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [quote, setQuote] = useState(); //Product details state
  const [user, setUser] = useState(); //Client details state
  const [product, setProduct] = useState(); //Product details state
  const [isloading, setLoading] = useState(true); //Loading isloading toggle

  const token = sessionStorage.getItem('token');

  // Query to get product data
  useEffect(() => {
    //check if user is logged in
    isLoggedIn(navigate, dispatch, `/quoterequest/${id}`);

    let active = true;

    (async () => {
      const response = await axios(url, {
        headers: { authorization: `Bearer ${token}` },
      });
      if (active) {
        setQuote(response.data);
        setUser(response.data.User);
        setProduct(response.data.Materiel);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
      setQuote(null);
      setUser(null);
      setProduct(null);
    };
  }, [id]);

  //handle listing valitaion

  // -----------------------------------------------------------------------------

  return isloading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS: Detailed price quote request</title>
        <meta name='page' content='detailed price quote request' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    <>
      <Helmet>
        <title>Badgers SAS: Detailed price quote request</title>
        <meta name='page' content='detailed price quote request' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className={`${styles.background} container`}>
        <Toaster position='top-center' reverseOrder={false} />
        {/* ------------Navlinks----------- */}
        <div className=''>
          <Link className='page-links' to='/'>
            <FontAwesomeIcon icon='home' />{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <Link className='page-links' to='/quoterequests'>
            PRICE QUOTE REQUESTS{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <span className='link-span'>{product.title}</span>
        </div>
        {/* ----------------------- */}
        <div className='col-12 d-flex justify-content-center my-4'>
          <h4 className='h4'>
            QUOTE REQUEST DETAILS <FontAwesomeIcon icon='calculator' />
          </h4>
        </div>
        <div className={`${styles.card} row g-4 my-3 pb-3`}>
          <QuoteDetails quote={quote} />
          <UserDetails user={user} />
        </div>
        <ProductDetails product={product} />
      </div>
    </>
  );
};

export default QuoteRequest;
